import * as React from 'react';
import { PieChart as RePieChart, Pie, Cell, Legend } from 'recharts';

const RADIAN = Math.PI / 180;

type Props = {
  data: { name: string; value: number }[];
  colors: string[];
};

function PieChart(props: Props) {
  const colors = props.colors;
  const data = props.data.filter((entry) => entry.value != 0);

  return (
    <RePieChart width={350} height={300}>
      <Pie
        data={data}
        dataKey='value'
        cx='48%'
        cy='50%'
        outerRadius={80}
        label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
          const radius = 25 + innerRadius + (outerRadius - innerRadius);
          const x = cx + radius * Math.cos(-midAngle * RADIAN);
          const y = cy + radius * Math.sin(-midAngle * RADIAN);
          return (
            <text x={x} y={y} fill='black' textAnchor={x > cx ? 'start' : 'end'} dominantBaseline='central'>
              {`${(percent * 100).toFixed(0)}%`}
            </text>
          );
        }}
      >
        {data.map((_, index) => (
          <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
        ))}
      </Pie>
      <Legend
        iconType='circle'
        align='right'
        verticalAlign='middle'
        layout='vertical'
        wrapperStyle={{ fontSize: '0.8rem' }}
      />
    </RePieChart>
  );
}

export default PieChart;
